import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "levami_admin_locale";
const AdminLocaleContext = createContext(null);

const ARABIC = {
  "language": "اللغة",
  "language.fr": "Français",
  "language.ar": "العربية",
  "admin": "الإدارة",
  "nav.overview": "نظرة عامة",
  "nav.dashboard": "لوحة التحكم",
  "nav.catalog": "الكتالوج",
  "nav.products": "المنتجات والمتغيرات",
  "nav.categories": "الفئات",
  "nav.media": "الوسائط",
  "nav.import": "استيراد",
  "nav.orders": "الطلبات",
  "nav.marketing": "التسويق",
  "nav.discounts": "الخصومات والقسائم",
  "nav.reviews": "تقييمات العملاء",
  "nav.lookbook": "دليل الإطلالات",
  "nav.content": "المحتوى",
  "nav.pages": "الصفحات والمحتوى",
  "nav.theme": "محرر التصميم",
  "nav.journal": "القصص وورش العمل",
  "nav.relationships": "العلاقات",
  "nav.crm": "جهات الاتصال والشراكات",
  "nav.b2b": "مساحة الشركات",
  "nav.settings": "الإعدادات",
  "nav.shipping": "الشحن وتحسين محركات البحث والعامة",
  "nav.users": "المستخدمون",
  "site.view": "عرض الموقع",
  "password.change": "تغيير كلمة المرور",
  "logout": "تسجيل الخروج",
  "menu": "القائمة",
  "dashboard.title": "لوحة التحكم",
  "dashboard.loading": "جارٍ التحميل...",
  "dashboard.sales": "إجمالي المبيعات",
  "dashboard.orders": "الطلبات",
  "dashboard.average": "متوسط قيمة السلة",
  "dashboard.coupons": "القسائم المستخدمة",
  "dashboard.revenue": "الإيرادات",
  "dashboard.recent": "الطلبات الأخيرة",
  "dashboard.no_orders": "لا توجد طلبات حتى الآن.",
  "dashboard.low_stock_none": "لا توجد منتجات منخفضة المخزون.",
  "dashboard.range7": "آخر 7 أيام",
  "dashboard.range30": "آخر 30 يوماً",
  "dashboard.range90": "آخر 90 يوماً",
  "dashboard.range365": "آخر 365 يوماً",
  "dashboard.used_coupons": "القسائم المستخدمة",
  "dashboard.paid_orders": "طلب مدفوع",
  "dashboard.average_cart": "متوسط قيمة السلة",
  "dashboard.refund_count": "عدد عمليات الاسترداد",
  "dashboard.ca": "الإيرادات",
  "dashboard.client": "العميل",
  "dashboard.total": "الإجمالي",
  "dashboard.top_products": "المنتجات الأكثر طلباً",
  "dashboard.no_data": "لا توجد بيانات حتى الآن.",
  "dashboard.sold": "تم بيع",
  "dashboard.favorites": "المنتجات الأكثر حفظاً في المفضلة",
  "dashboard.restock_priority_single": "منتج محفوظ في المفضلة نفد من المخزون — أولوية لإعادة التزويد.",
  "dashboard.restock_priority_many": "منتجات محفوظة في المفضلة نفدت من المخزون — أولوية لإعادة التزويد.",
  "dashboard.sold_out": "نفد من المخزون — يلزم إعادة التزويد",
  "dashboard.saved": "محفوظ",
  "dashboard.adds": "إضافة",
  "dashboard.current_stock": "المخزون الحالي",
  "dashboard.low_stock": "مخزون منخفض (≤ 3)",
  "dashboard.remaining": "متبقٍ",
  "dashboard.gross_sales": "إجمالي المبيعات",
  "dashboard.refunded_amount": "المبالغ المستردة",
  "dashboard.net_sales": "صافي المبيعات",
  "dashboard.period_orders": "الطلبات المدفوعة",
  "dashboard.period_average": "متوسط قيمة الطلب",
  "dashboard.period_coupons": "القسائم المستخدمة",
  "dashboard.top_products_period": "في الطلبات المدفوعة خلال الفترة المحددة",
  "dashboard.recent_selected_currency": "أحدث الطلبات بالعملة المحددة",
  "dashboard.low_stock_all": "جميع العملات · المنتجات الأقل مخزوناً أولاً",
  "dashboard.net_revenue_chart": "الإيراد الصافي يومياً",
  "dashboard.range_note": "المبيعات حسب تاريخ الطلب؛ والمبالغ المستردة حسب تاريخ الاسترداد.",
  "dashboard.currency": "العملة",
  "dashboard.status_all_time": "توزيع حالات الطلبات (كل الفترات)",
  "dashboard.loading_error": "تعذر تحميل بيانات لوحة التحكم.",
  "dashboard.try_again": "إعادة المحاولة",
  "dashboard.wishlist_error": "تعذر تحميل إحصاءات المفضلة.",
  "dashboard.gross": "إجمالي",
  "dashboard.refunds": "المبالغ المستردة",
  "dashboard.net": "الصافي",
  "dashboard.orders_axis": "الطلبات",
  "dashboard.chart_legend": "مفاتيح الرسم البياني",
  "orders.title": "الطلبات",
  "orders.saved": "تم تحديث الطلب.",
  "orders.order": "الطلب",
  "orders.search": "ابحث برقم الطلب أو العميل أو المنتج",
  "orders.export": "تصدير CSV",
  "orders.date": "التاريخ",
  "orders.client": "العميل",
  "orders.items": "المنتجات",
  "orders.total": "الإجمالي",
  "orders.payment": "الدفع",
  "orders.no_orders": "لا توجد طلبات حتى الآن.",
  "orders.pending_warning": "الدفع قيد الانتظار — لا تجهز الطلب أو تشحنه قبل تأكيد الدفع.",
  "orders.address": "العنوان",
  "orders.subtotal": "المجموع الفرعي",
  "orders.discount": "الخصم",
  "orders.shipping": "الشحن",
  "orders.tracking": "تتبع الطلب",
  "orders.shipped_at": "تم الشحن في",
  "orders.carrier": "شركة الشحن",
  "orders.tracking_number": "رقم التتبع",
  "orders.internal_notes": "ملاحظات داخلية",
  "orders.save": "حفظ",
  "orders.packing_slip": "قسيمة التجهيز",
  "orders.invoice": "الفاتورة",
  "orders.resend_email": "إعادة إرسال البريد",
  "orders.refund": "استرداد المبلغ",
  "orders.demo_notice": "وضع العرض المحلي: الطلب المعروض تجريبي، ولا تؤثر الإجراءات على الطلبات الحقيقية.",
  "orders.email_sent": "تم إرسال البريد الإلكتروني إلى العميل.",
  "orders.confirm_refund": "هل تؤكد استرداد قيمة هذا الطلب؟",
  "orders.resend_email_help": "أعد إرسال الرسالة المرتبطة بالحالة الحالية إلى العميل (مثلاً بعد إضافة رقم التتبع).",
  "orders.refund": "استرداد المبلغ",
  "crm.title": "جهات الاتصال والشراكات",
  "crm.subtitle": "أدر الطلبات الواردة واعثر على الرسائل بسرعة.",
  "crm.refresh": "تحديث",
  "crm.status_updated": "تم تحديث الحالة.",
  "crm.contacts": "رسائل التواصل",
  "crm.partnerships": "طلبات الشراكة",
  "crm.pending": "بانتظار المعالجة",
  "crm.tab_contacts": "رسائل التواصل",
  "crm.tab_partnerships": "الشراكات",
  "crm.newsletter": "النشرة البريدية",
  "crm.search_contact": "ابحث بالاسم أو البريد أو الموضوع أو الرسالة...",
  "crm.search_partnership": "ابحث بالاسم أو المؤسسة أو البريد...",
  "crm.search_newsletter": "ابحث عن عنوان بريد إلكتروني...",
  "crm.search_label_contacts": "البحث في رسائل التواصل",
  "crm.search_label_partnerships": "البحث في الشراكات",
  "crm.search_label_newsletter": "البحث في النشرة البريدية",
  "crm.filter_status": "تصفية حسب الحالة",
  "crm.all_statuses": "كل الحالات",
  "crm.date": "التاريخ",
  "crm.name": "الاسم",
  "crm.subject": "الموضوع",
  "crm.message": "الرسالة",
  "crm.status": "الحالة",
  "crm.organization": "المؤسسة",
  "crm.type": "النوع",
  "crm.contact": "جهة الاتصال",
  "crm.read_message": "قراءة الرسالة",
  "crm.no_messages": "لا توجد رسائل حتى الآن.",
  "crm.no_requests": "لا توجد طلبات حتى الآن.",
  "crm.no_subscribers": "لا يوجد مشتركون حتى الآن.",
  "crm.no_matches": "لا توجد نتائج مطابقة لبحثك.",
  "crm.loading_messages": "جارٍ تحميل الرسائل...",
  "crm.loading_requests": "جارٍ تحميل الطلبات...",
  "crm.loading_subscribers": "جارٍ تحميل المشتركين...",
  "crm.load_error": "تعذر تحميل جميع البيانات:",
  "crm.retry": "إعادة المحاولة",
  "crm.subscribers_shown": "مشترك معروض",
  "crm.export": "تصدير CSV",
  "crm.from": "من",
  "crm.email": "البريد الإلكتروني",
  "crm.order_number": "رقم الطلب",
  "crm.partnership_type": "نوع الشراكة",
  "crm.phone": "الهاتف",
  "crm.city_country": "المدينة / البلد",
  "crm.partnership_request": "طلب شراكة",
  "crm.reply_email": "الرد عبر البريد الإلكتروني",
  "crm.reply_subject": "طلب الشراكة",
  "crm.message_subject": "رسالتك إلى LEVAMI",
  "status.nouveau": "جديد",
  "status.en_cours": "قيد المعالجة",
  "status.repondu": "تم الرد",
  "status.archive": "مؤرشف",
  "status.en_attente": "قيد الانتظار",
  "status.payee": "مدفوع",
  "status.en_preparation": "قيد التحضير",
  "status.expediee": "تم الشحن",
  "status.livree": "تم التسليم",
  "status.annulee": "ملغي",
  "status.remboursee": "تم رد المبلغ",
  "status.echoue": "فشل",
  "status.remboursee_partiel": "تم رد جزء من المبلغ",
  "common.save": "حفظ",
  "common.cancel": "إلغاء",
  "common.edit": "تعديل",
  "common.delete": "حذف",
  "common.add": "إضافة",
  "common.search": "بحث",
  "common.yes": "نعم",
  "common.no": "لا",
  "login.title": "بوابة الإدارة",
  "login.forgot_title": "نسيت كلمة المرور",
  "login.forgot": "نسيت كلمة المرور",
  "login.password": "كلمة المرور",
  "login.connecting": "جارٍ تسجيل الدخول...",
  "login.sending": "جارٍ الإرسال...",
  "login.signin": "تسجيل الدخول",
  "login.invalid": "بيانات تسجيل الدخول غير صحيحة.",
  "login.email": "البريد الإلكتروني",
  "login.send": "إرسال الرابط",
  "login.back": "العودة إلى تسجيل الدخول",
  "login.email_help": "أدخل عنوان البريد الإلكتروني لحساب المسؤول. سنرسل إليك رابط إعادة تعيين صالحاً لمدة 60 دقيقة.",
  "login.reset_sent": "إذا كان هناك حساب مرتبط بهذا العنوان، فسيتم إرسال رسالة إعادة تعيين كلمة المرور.",
  "login.spam": "يرجى التحقق من مجلد البريد غير المرغوب فيه.",
  "login.demo": "وضع العرض المحلي",
  "login.demo_email": "البريد الإلكتروني: admin-test@levami.local",
  "login.demo_password": "كلمة المرور: levami-test",
  "login.forgot_link": "نسيت كلمة المرور؟",
  "login.demo_warning": "بيانات تجريبية. عمليات الدفع وتغييرات الموقع الحقيقي معطلة.",
};

export function AdminLocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "ar" ? "ar" : "fr";
    } catch {
      return "fr";
    }
  });

  const setLocale = useCallback((nextLocale) => {
    const next = nextLocale === "ar" ? "ar" : "fr";
    setLocaleState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // Keep the in-memory selection if browser storage is unavailable.
    }
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    const previousDirection = root.dir;
    const previousLanguage = root.lang;
    root.dir = locale === "ar" ? "rtl" : "ltr";
    root.lang = locale;
    return () => {
      root.dir = previousDirection;
      root.lang = previousLanguage;
    };
  }, [locale]);

  const tAdmin = useCallback((key, fallback = key) => {
    if (locale === "ar") return ARABIC[key] || fallback;
    return fallback;
  }, [locale]);
  const translate = useCallback((french, arabic) => (
    locale === "ar" ? arabic : french
  ), [locale]);

  const value = useMemo(() => ({
    locale,
    direction: locale === "ar" ? "rtl" : "ltr",
    setLocale,
    tAdmin,
    translate,
  }), [locale, setLocale, tAdmin, translate]);

  return <AdminLocaleContext.Provider value={value}>{children}</AdminLocaleContext.Provider>;
}

export function useAdminLocale() {
  const context = useContext(AdminLocaleContext);
  if (!context) throw new Error("useAdminLocale must be used within AdminLocaleProvider");
  return context;
}

// Shared controls also appear outside the admin portal; keep their existing defaults there.
export function useOptionalAdminLocale() {
  return useContext(AdminLocaleContext);
}
